export { default } from "./TickerAsLink";
